// export * as humanModifier from './human/human-modifier.js'
// export * as human from './human/human.js'
// export * as targets from './human/targets.js'
// export * from './human/human-modifier.js'
// export * from './human/proxy.js'
// export * from './human/factors.js'
export * from './js/human'



// WEBPACK FOOTER //
// ./src/bundle.js